import { useRef } from "react";
import { StandaloneSearchBox } from "@react-google-maps/api";

const GmapPlaceSearchBox = ({
  input,
  label,
  onChange,
  id,
  name,
  value,
  placeholder,
  updateDestination,
  index,
}) => {
  const placeRef = useRef();
  // const dispatch = useDispatch();
  const placeChangeHandler = () => {
    const [place] = placeRef.current.getPlaces();
    console.log(place);
    if (place != undefined) {
      let streetNumber = "";
      let route = "";
      let country = "";
      let postalCode = "";
      let locality = "";
      const placeId = place?.place_id;
      const name = place?.name;
      const address = place?.formatted_address;
      const lat = place?.geometry.location.lat();
      const lng = place?.geometry.location.lng();

      place?.address_components?.map((address_component) => {
        if (address_component?.types[0] === "street_number") {
          streetNumber = address_component?.long_name;
        } else if (address_component?.types[0] === "route") {
          route = address_component?.long_name;
        } else if (address_component?.types[0] === "country") {
          country = address_component?.long_name;
        } else if (address_component?.types[0] === "locality") {
          locality = address_component?.long_name;
        } else if (address_component?.types[0] === "postal_code") {
          postalCode = address_component?.long_name;
        }
      });

      updateDestination(
        streetNumber,
        route,
        country,
        locality,
        postalCode,
        placeId,
        name,
        address,
        lat,
        lng,
        index
      );
    }
  };

  const unMountHandler = () => {
    console.log("unmounted");
  };

  // / dispatch(TourAddressActions.setIsDataChanged(true));

  return (
    <>
      <div className="w-full pt-3 ">
        <div className="border-[1px]  relative rounded-[0.3rem] transition-all ease-in-out duration-100  border-[#79747E] focus:border-[#79747E] outline-0 font-lato text-[1rem] w-full leading-normal  py-[1rem] px-[1.4rem]">
          <StandaloneSearchBox
            onLoad={(ref) => (placeRef.current = ref)}
            onPlacesChanged={placeChangeHandler}
            onUnmount={unMountHandler}
          >
            <>
              <input
                {...input}
                placeholder={"Keresés célállomásra"}
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                className="w-full font-normal border-0 outline-0 tracking-[0.5px] placeholder-text-place-holder text-text-primary-color"
              />
            </>
          </StandaloneSearchBox>
          <label className="absolute font-normal text-[0.75rem] -translate-y-1/2 -top-[2px] left-4 bg-white px-2 font">
            {label}
          </label>
        </div>
      </div>
      {/* {touched && error && <span>{error}</span>} */}
    </>
  );
};

export default GmapPlaceSearchBox;
